export default __webpack_public_path__ + "static/media/about.a46f4717.jpg";